import React, { useContext, useRef } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import TiTroviIn from "@/widget/TiTroviIn";
import LogoParita from "../../../img/logoheaderpage.png";
var Cookies = observer(function (props) {
  var rootStore = useContext(StoreContext).rootStore;
  var isMounted = useRef(false);
  var BREADCRUMB_TITOLO = "Preferenze Cookies";
  var BREADCRUMB_CHILDREN = [{
    to: process.env.CONTEXT_PATH + "/home",
    label: "Home"
  }];
  var breadcrumb = /*#__PURE__*/React.createElement(TiTroviIn, {
    children: BREADCRUMB_CHILDREN,
    title: BREADCRUMB_TITOLO
  });
  return rootStore.uiStore.numberCallback === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "postizioneLogoHeader"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoParita,
    alt: "",
    className: "img-fluid dimImage"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, breadcrumb, /*#__PURE__*/React.createElement("div", {
    className: "row altezzaMin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h1", null, "Preferenze cookies"), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "La navigazione in questo sito internet e l\u2019utilizzo dei relativi servizi comporta la ricezione di cookie tecnici e di profilazione di terze parti, per assicurarti la migliore esperienza di navigazione e permetterti di visualizzare alcuni contenuti disponibili sui canali social UNAR di Twitter e YouTube direttamente all\u2019interno del presente Sito, in linea con le tue preferenze. Per saperne di pi\xF9 consulta la ", /*#__PURE__*/React.createElement("a", {
    href: process.env.CONTEXT_PATH + "/privacy-policy",
    className: "font-weight-bold text-decoration-underline",
    target: "_black"
  }, "PRIVACY POLICY", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Pricacy Policy: apre una nuova finestra")), "."), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "Puoi utilizzare questa funzionalit\xE0 per effettuare la tua scelta prestando singolarmente il consenso ai cookie di seguito indicati."))))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }))));
});
export default Cookies;